import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=529ddf63&scoped=true&lang=html&"
import script from "./Link.vue?vue&type=script&lang=js&"
export * from "./Link.vue?vue&type=script&lang=js&"
import style0 from "./Link.vue?vue&type=style&index=0&id=529ddf63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529ddf63",
  null
  
)

component.options.__file = "Link.vue"
export default component.exports